/* Family Matrix Picker — vanilla JS, no deps. */
(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  function safeJSON(text, fallback) {
    try { return JSON.parse(text); } catch (e) { return fallback; }
  }

  function moneyFormat(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function init() {
    var section = $('.fmp');
    if (!section) return;

    var variants = safeJSON($('#fmp-variants').textContent, []);
    var options  = safeJSON($('#fmp-options').textContent, []);
    var images   = safeJSON($('#fmp-images').textContent, []);
    var mode     = section.dataset.mode || 'simple';
    var pickerOrder = safeJSON(section.dataset.pickerOrder, []);
    var pickerDefaults = safeJSON(section.dataset.pickerDefaults, {});
    var pickerMulti = safeJSON(section.dataset.pickerMulti, []);

    if (!pickerOrder.length) {
      pickerOrder = options.map(function (o) { return o.name; });
    }

    var state = {};

    function variantsMatching(excludeAxis) {
      return variants.filter(function (v) {
        return pickerOrder.every(function (axis, idx) {
          if (axis === excludeAxis) return true;
          if (state[axis] == null) return true;
          var optionVal = v['option' + (idx + 1)];
          return optionVal === state[axis];
        });
      });
    }

    // Cascade narrows DOWNSTREAM only: each axis filters by axes earlier
    // in pickerOrder. Size shows ALL sizes; Color narrows by chosen Size;
    // Digit narrows by chosen Size+Color.
    function valuesForAxis(axis) {
      var seen = {};
      var axisIdx = pickerOrder.indexOf(axis);
      variants.forEach(function (v) {
        var ok = pickerOrder.every(function (a, i) {
          if (i >= axisIdx) return true;
          if (state[a] == null) return true;
          var optionVal = v['option' + (i + 1)];
          return optionVal === state[a];
        });
        if (!ok) return;
        var val = v['option' + (axisIdx + 1)];
        if (val) seen[val] = true;
      });
      return Object.keys(seen);
    }

    function findExactVariant(stateOverride) {
      var s = stateOverride || state;
      return variants.find(function (v) {
        return pickerOrder.every(function (axis, idx) {
          var val = v['option' + (idx + 1)];
          return val === s[axis];
        });
      });
    }

    function sortValues(axis, values) {
      var allNumeric = values.every(function (v) {
        return /^[\d./" ]+$/.test(v);
      });
      if (allNumeric) {
        return values.slice().sort(function (a, b) {
          return parseFloat(a) - parseFloat(b);
        });
      }
      return values.slice().sort();
    }

    var pickersHost = $('#fmp-pickers');
    var multiAxes = (mode === 'matrix') ? pickerMulti : [];

    pickerOrder.forEach(function (axis) {
      if (multiAxes.indexOf(axis) !== -1) return;
      var row = document.createElement('div');
      row.className = 'fmp__picker-row';
      row.dataset.axis = axis;
      var label = document.createElement('label');
      label.textContent = axis;
      label.setAttribute('for', 'fmp-axis-' + axis.replace(/\W+/g, '-'));
      row.appendChild(label);
      var sel = document.createElement('select');
      sel.id = 'fmp-axis-' + axis.replace(/\W+/g, '-');
      sel.dataset.axis = axis;
      row.appendChild(sel);
      pickersHost.appendChild(row);
    });

    function refreshDropdowns() {
      pickerOrder.forEach(function (axis) {
        if (multiAxes.indexOf(axis) !== -1) return;
        var sel = $('select[data-axis="' + axis + '"]', pickersHost);
        if (!sel) return;
        var prev = state[axis];
        var values = sortValues(axis, valuesForAxis(axis));
        sel.innerHTML = '';
        if (!values.length) {
          state[axis] = null;
          var opt = document.createElement('option');
          opt.textContent = 'No options available';
          opt.disabled = true;
          sel.appendChild(opt);
          sel.disabled = true;
          return;
        }
        sel.disabled = false;
        values.forEach(function (v) {
          var opt = document.createElement('option');
          opt.value = v;
          opt.textContent = v;
          sel.appendChild(opt);
        });
        var pick;
        if (prev != null && values.indexOf(prev) !== -1) {
          pick = prev;
        } else if (pickerDefaults[axis] && values.indexOf(pickerDefaults[axis]) !== -1) {
          pick = pickerDefaults[axis];
        } else {
          pick = values[0];
        }
        sel.value = pick;
        state[axis] = pick;
      });
    }

    function refreshGrid() {
      var grid = $('#fmp-grid');
      if (!grid || mode !== 'matrix' || !multiAxes.length) return;
      var gridAxis = multiAxes[0];
      var values = valuesForAxis(gridAxis);
      values.sort(function (a, b) {
        var na = parseFloat(a), nb = parseFloat(b);
        if (!isNaN(na) && !isNaN(nb)) return na - nb;
        return String(a).localeCompare(String(b));
      });
      grid.innerHTML = '';
      // Always 3 rows. Compute columns so values fill 3 rows compactly.
      var rows = 3;
      var cols = Math.max(1, Math.ceil(values.length / rows));
      grid.style.gridTemplateColumns = 'repeat(' + cols + ', 1fr)';
      grid.classList.add('fmp__grid--compact');
      values.forEach(function (v) {
        var cell = document.createElement('div');
        cell.className = 'fmp__grid-cell';
        var lab = document.createElement('label');
        lab.textContent = v;
        var inp = document.createElement('input');
        inp.type = 'number';
        inp.min = '0';
        inp.value = '0';
        inp.dataset.gridValue = v;
        inp.inputMode = 'numeric';
        cell.appendChild(lab);
        cell.appendChild(inp);
        grid.appendChild(cell);
      });
    }

    function imageSrcForVariant(v) {
      if (v && v.featured_image) {
        return v.featured_image.src || v.featured_image;
      }
      if (v && v.image) {
        return v.image.src || v.image;
      }
      if (images && images[0]) return images[0].src || images[0];
      return null;
    }

    function refreshPriceAndImage() {
      var v = findExactVariant() || variantsMatching().pop() || variants[0];
      if (v && v.price != null) {
        $('#fmp-price').textContent = moneyFormat(v.price);
      }
      var heroImg = $('#fmp-hero-img');
      if (!heroImg) return;
      var src = imageSrcForVariant(v);
      if (src && heroImg.src !== src) {
        heroImg.style.opacity = '0.4';
        var pre = new Image();
        pre.onload = function () {
          heroImg.src = src;
          heroImg.style.opacity = '1';
        };
        pre.onerror = function () { heroImg.style.opacity = '1'; };
        pre.src = src;
      }
    }

    function setDefaults() {
      pickerOrder.forEach(function (axis) {
        if (pickerDefaults[axis] != null) state[axis] = pickerDefaults[axis];
      });
    }

    setDefaults();
    refreshDropdowns();
    refreshGrid();
    refreshPriceAndImage();

    $$('select[data-axis]', pickersHost).forEach(function (sel) {
      sel.addEventListener('change', function () {
        state[sel.dataset.axis] = sel.value;
        refreshDropdowns();
        refreshGrid();
        refreshPriceAndImage();
      });
    });

    function buildCartItems() {
      if (mode === 'matrix' && multiAxes.length) {
        var gridAxis = multiAxes[0];
        var items = [];
        $$('#fmp-grid input[data-grid-value]').forEach(function (inp) {
          var qty = parseInt(inp.value, 10) || 0;
          if (qty <= 0) return;
          var s = Object.assign({}, state);
          s[gridAxis] = inp.dataset.gridValue;
          var v = findExactVariant(s);
          if (v) items.push({ id: v.id, quantity: qty });
        });
        return items;
      } else {
        var qty = parseInt(($('#fmp-qty') || {}).value || '1', 10);
        var v = findExactVariant();
        return v ? [{ id: v.id, quantity: qty }] : [];
      }
    }

    var feedback = $('#fmp-feedback');
    function setFeedback(msg, kind) {
      feedback.textContent = msg;
      feedback.className = 'fmp__feedback' + (kind ? ' ' + kind : '');
    }

    var form = $('#fmp-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var items = buildCartItems();
        if (!items.length) {
          setFeedback('Pick at least one item to add.', 'err');
          return;
        }
        var btn = $('#fmp-add');
        btn.disabled = true;
        setFeedback('Adding to cart...', '');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            var n = items.reduce(function (a, it) { return a + it.quantity; }, 0);
            setFeedback('Added ' + n + ' item' + (n === 1 ? '' : 's') + ' to cart.', 'ok');
            var badge = $('.cart-count-bubble span[aria-hidden="true"]');
            if (badge) badge.textContent = (parseInt(badge.textContent, 10) || 0) + n;
          })
          .catch(function () {
            setFeedback('Could not add to cart. Please try again.', 'err');
          })
          .finally(function () { btn.disabled = false; });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
